module.exports = __webpack_public_path__ + "components/country-flag/static/dj-25f445a662c9e26f4d292fd890dd47dc.svg";